/** Tag keys map 1-to-1 with boolean columns in shop_profiles (TAG_COLUMNS on the
 *  server). Shared by ShopProfilePage (display) and OwnerSubmissionPage (owner
 *  confirmation) — keep one copy so the two can never drift. */

export const CATEGORY_META = {
  coffee: { title: "The Coffee", emoji: "☕" },
  vibe:   { title: "Good For",   emoji: "💻" },
  place:  { title: "The Place",  emoji: "🏠" },
};

export const ALL_TAGS = {
  coffee: [
    { key: "specialty_coffee",  label: "Specialty coffee" },
    { key: "pour_over",         label: "Pour-over available" },
    { key: "espresso_focused",  label: "Espresso focused" },
    { key: "alternative_milks", label: "Alternative milks" },
    { key: "rotating_menu",     label: "Rotating seasonal menu" },
    { key: "house_roasted",     label: "House roasted" },
  ],
  vibe: [
    { key: "good_wifi",       label: "Good wifi" },
    { key: "laptop_friendly", label: "Laptop friendly" },
    { key: "long_stays",      label: "Long stays welcome" },
    { key: "outdoor_seating", label: "Outdoor seating" },
    { key: "reading",         label: "Good for reading" },
    { key: "dog_friendly",    label: "Dog friendly" },
  ],
  place: [
    { key: "single_location", label: "Single location" },
    { key: "owner_present",   label: "Owner behind the counter" },
    { key: "food_pastries",   label: "Food / pastries" },
    { key: "beans_retail",    label: "Beans to buy retail" },
  ],
};

export const TAG_LIST = Object.values(ALL_TAGS).flat();
